import { render, staticRenderFns } from "./DrawArea.vue?vue&type=template&id=06f9bf4c&scoped=true&"
import script from "./DrawArea.vue?vue&type=script&lang=ts&"
export * from "./DrawArea.vue?vue&type=script&lang=ts&"
import style0 from "./DrawArea.vue?vue&type=style&index=0&id=06f9bf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9bf4c",
  null
  
)

export default component.exports